import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vee-validate';
import '@/plugins/snackbar';
import '@/plugins/dialog';
import '@/plugins/alert';
import '@/plugins/dayjs';
import '@/plugins/vuep';
import '@/plugins/class-component-hooks';
import '@/plugins/vue-splash';
import '@/api';
import 'nprogress/nprogress.css';
import '@/assets/scss/nprogress.scss';
import '@mdi/font/scss/materialdesignicons.scss';

import wb from '@/sw';
import {registerWatchLoader} from '@/utils/loader';
import '@/utils/filters';
import i18n from './plugins/i18n';
import config from './config';
import '@/plugins/vue-components';
import {can} from '@/services/acl.service';
import DisableAutocomplete from 'vue-disable-autocomplete';

Vue.use(DisableAutocomplete);

Vue.config.productionTip = false;

registerWatchLoader(store);

Vue.prototype.$workbok = wb;
Vue.prototype.$appConfig = config;

/**
 * $can prototype for checking user permissions access.
 *
 * @param permissions
 */
Vue.prototype.$can = can;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
